import styled from 'styled-components';

export const Container = styled.div`
  margin: 30px auto;
  width: 100%;
  max-width: 900px;
`;



// WEBPACK FOOTER //
// ./src/containers/Home/NetMetering/styles.js